import { settings } from '../../../settings/settings-util'
import UserRequestProcessor from './request-processor-user'
import UserResponseHandler from './response-handler-user'

export default class UserManager
{
    constructor(passedSettings)
    {
        this._settings = passedSettings || settings;
        this._reqProc = new UserRequestProcessor(this._settings);
        this._respHandler = new UserResponseHandler(this._settings);
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getRequestProcessor()
    {
        return this._reqProc;
    }

    getResponseHandler()
    {
        return this._respHandler;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/user/src/user.js